import PropTypes from "prop-types";
// material-ui
import { useTheme } from "@mui/material/styles";

// project-imports
import DrawerHeaderStyled from "./DrawerHeaderStyled";

import Logo from "components/logo";
import { HEADER_HEIGHT } from "config";

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        minHeight: HEADER_HEIGHT,
        width: "inherit",
        paddingY: 2.5,
        paddingX: 0,
        display: "flex",
        justifyContent: "center",
      }}
    >
      {/* dark=true → white logo assets (for teal rail) */}
      <Logo isIcon={!open} dark sx={{ width: open ? "auto" : 52, height: "auto" }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
